import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "min-w-0 flex-1 flex items-start gap-3" }
const _hoisted_2 = { class: "min-w-0" }
const _hoisted_3 = ["id"]


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminModalHeader',
  props: {
    title: {},
    subtitle: {},
    showClose: { type: Boolean, default: true },
    variant: { default: "dark" },
    headingId: {},
    topRounded: { type: Boolean, default: true }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["px-5 sm:px-6 py-4 sm:py-5 border-b flex items-start justify-between gap-3 min-w-0", [
      __props.topRounded ? 'rounded-t-2xl' : '',
      __props.variant === 'dark'
        ? 'bg-gradient-to-r from-slate-900 to-slate-700 border-slate-600/30'
        : 'bg-slate-50 border-slate-200',
    ]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.$slots.icon)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["shrink-0 text-white", __props.variant === 'light' ? '!text-slate-700' : ''])
          }, [
            _renderSlot(_ctx.$slots, "icon")
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", {
          id: __props.headingId,
          class: _normalizeClass(["text-lg sm:text-xl font-bold leading-tight break-words", __props.variant === 'dark' ? 'text-white' : 'text-slate-900'])
        }, _toDisplayString(__props.title), 11, _hoisted_3),
        (__props.subtitle)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(["mt-1 text-sm break-words", __props.variant === 'dark' ? 'text-slate-300' : 'text-slate-600'])
            }, _toDisplayString(__props.subtitle), 3))
          : _createCommentVNode("", true)
      ])
    ]),
    (__props.showClose)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: _normalizeClass(["shrink-0 rounded-lg p-2 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2", 
        __props.variant === 'dark'
          ? 'text-white hover:bg-white/15 focus-visible:ring-white/50'
          : 'text-slate-500 hover:bg-slate-200/80 focus-visible:ring-slate-400'
      ]),
          "aria-label": "Cerrar",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("svg", {
            class: "w-5 h-5 sm:w-6 sm:h-6",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })
          ], -1)
        ]))], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})